import type { TooltipPassThroughMethodOptions } from 'primevue/tooltip'

export default {
  // eslint-disable-next-line complexity
  arrow: ({ context }: TooltipPassThroughMethodOptions) => ({
    class: [
      // Position

      'absolute',

      // Size
      'w-0',
      'h-0',

      // Shape
      'border-transparent',
      'border-solid',
      {
        'border-x-[10px] border-b-[10px] border-t-0 border-b-surface-900':
          context?.bottom,
        'border-x-[10px] border-t-[10px] border-b-0 border-t-surface-900':
          context?.top,
        'border-y-[10px] border-l-[10px] border-r-0 border-l-surface-900':
          context?.left,
        'border-y-[10px] border-r-[10px] border-l-0 border-r-surface-900':
          context?.right ||
          (!context?.right &&
            !context?.left &&
            !context?.top &&
            !context?.bottom),
      },

      // Spacing
      {
        '-ml-[10px] left-1/2': context?.top || context?.bottom,
        '-mt-[10px] top-1/2':
          context?.right ||
          context?.left ||
          (!context?.right &&
            !context?.left &&
            !context?.top &&
            !context?.bottom),
      },
    ],
  }),
  root: ({ context }: TooltipPassThroughMethodOptions) => ({
    class: [
      // Position and Shadows
      'absolute',
      'p-fadein',
      // Spacing
      {
        'py-0 px-1':
          context?.right ||
          context?.left ||
          (!context?.right &&
            !context?.left &&
            !context?.top &&
            !context?.bottom),
        'py-1 px-0': context?.top || context?.bottom,
      },
    ],
  }),
  text: {
    class: [
      'body-2-regular',
      'py-2 pl-2 pr-2',
      'bg-surface-900',
      'text-white',
      'rounded-md',
      'whitespace-pre-line',
      'break-words',
    ],
  },
}
